import PropTypes from 'prop-types'
import { useRef, useMemo } from 'react'

import styles from './FlashingBlock.module.scss'

const FlashingBlock = ({ children, ...props }) => {
  const block = useRef()
  const randomInterval = useMemo(() => Math.floor(Math.random() * (15 - 5 + 1) + 5) * 1000, [])

  const handleResetAnimation = () => {
    block?.current?.classList.remove('animate')

    setTimeout(() => {
      block?.current?.classList.add('animate')
    }, randomInterval)
  }

  return (
    <div className={`animate ${styles.FlashingBlock}`} onAnimationEnd={handleResetAnimation} ref={block} {...props}>
      {children}
    </div>
  )
}

FlashingBlock.propTypes = {
  children: PropTypes.node
}

FlashingBlock.defaultProps = {
  children: null
}

export default FlashingBlock
